import { render, staticRenderFns } from "./formCkeditor.vue?vue&type=template&id=53591192&"
import script from "./formCkeditor.vue?vue&type=script&lang=js&"
export * from "./formCkeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports